import axiosInstance, {headers} from './axiosInstance';

export interface CompensatoryDates{
    compensatory_days: string[]
}


export const api = {
  async getAllCompensatoryDates() {
    return axiosInstance.get<CompensatoryDates>(`/compensatory_dates`, {headers});
  },
  async addCompensatoryDate(date: string) {
    // date should be in dd-MM-yyyy format
    return axiosInstance.post(`/compensatory_dates`, {date}, {headers});
  },
  async deleteCompensatoryDate(id: string) {
    return axiosInstance.delete(`/compensatory_dates/${id}`, {headers});
  },
};
